import { PersistentTelemetryDataContext } from "@amzn/xb-hooks";
import { PropsWithChildren } from "react";

export type PersistentTelemetryDataHook = () => {
  data: Record<string, string>;
  isReadyToEmit: boolean;
};

export const DEFAULT_USE_PERSISTENT_TELEMETRY_HOOK = () => ({ data: {}, isReadyToEmit: true });

export const PersistentTelemetryDataProvider = ({
  children,
  usePersistentTelemetryData,
}: PropsWithChildren<{ usePersistentTelemetryData: PersistentTelemetryDataHook }>) => {
  return (
    <PersistentTelemetryDataContext.Provider value={usePersistentTelemetryData()}>
      {children}
    </PersistentTelemetryDataContext.Provider>
  );
};
